import { FunctionComponent } from 'react'

/**
 * Easter egg. What the `+30%` button leaves behind: the app is gone and a 404 stands where it was.
 *
 * Nothing here navigates and nothing is persisted, so a reload brings the app back.
 */
export const UpliftNotFound: FunctionComponent = () => (
  <div className={'fixed inset-0 z-[9999] flex flex-col items-center justify-center gap-4 bg-white text-center'}>
    <div className={'font-rubik text-[160px] leading-none font-light text-king'}>404</div>
    <h1 className={'font-rubik text-2xl font-normal text-ink'}>Not found</h1>
    <p className={'font-roboto text-base text-slate-grey'}>The page you asked for does not exist. Neither did the uplift.</p>
  </div>
)
